// extracted by mini-css-extract-plugin
export default {"title":"style_title__e4UKO"};